(function () {
  'use strict';

  var STORAGE_KEY = 'theme:recently-viewed';
  var MAX_ITEMS = 20;

  function readList() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function writeList(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function logCurrentProduct() {
    var loggers = document.querySelectorAll('[data-log-recently-viewed]');
    loggers.forEach(function (el) {
      var handle = el.getAttribute('data-log-recently-viewed');
      if (!handle) return;
      var list = readList().filter(function (h) { return h !== handle; });
      list.unshift(handle);
      if (list.length > MAX_ITEMS) list.length = MAX_ITEMS;
      writeList(list);
    });
  }

  function fetchCard(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '?view=card', {
      headers: { 'Accept': 'text/html' },
      credentials: 'same-origin'
    })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (text) {
        if (!text) return null;
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var card = doc.querySelector('.product-item');
        return card ? card.outerHTML : null;
      })
      .catch(function () { return null; });
  }

  function hideRVTab(container) {
    var group = container.closest('[data-tab-group]');
    var panelId = container.getAttribute('data-panel');
    if (group && panelId) {
      var tab = group.querySelector('[data-tab="' + panelId + '"]');
      if (tab) tab.hidden = true;
    }
    container.hidden = true;
  }

  function showRVTab(container) {
    var group = container.closest('[data-tab-group]');
    var panelId = container.getAttribute('data-panel');
    if (group && panelId) {
      var tab = group.querySelector('[data-tab="' + panelId + '"]');
      if (tab) tab.hidden = false;
    }
  }

  var PREV_SVG = '<span class="css-slider-button css-slider-prev" style="display:none"><svg fill="none" height="11" viewBox="0 0 6 11" width="6" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m4.32845 10.0708-4.18198-4.18194c-.195261-.19526-.195261-.51185 0-.70711l4.18198-4.181979c.19527-.195262.51185-.195262.70711 0 .19526.195259.19526.511849 0 .707109l-3.32843 3.32842s-.70713.4647-.00002 1l3.32845 3.32843c.19526.19526.19526.51185 0 .70707-.19526.1953-.51185.1953-.70711 0z" fill="#000" fill-rule="evenodd"/></svg></span>';
  var NEXT_SVG = '<span class="css-slider-button css-slider-next" style="display:none"><svg fill="none" height="11" viewBox="0 0 6 11" width="6" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m.853555.999962 4.181985 4.181978c.19526.19526.19526.51185 0 .70711l-4.181983 4.18195c-.195263.1953-.511845.1953-.707108 0-.1952631-.19523-.1952632-.51181 0-.70708l3.328431-3.32842s.70713-.4647.00002-1l-3.328453-3.32843c-.1952626-.19526-.1952627-.51185 0-.707108.195263-.195262.511845-.195262.707108 0z" fill="#000" fill-rule="evenodd"/></svg></span>';

  function buildSliderHTML(cardHTML) {
    var options = {
      selector: '.product-item',
      groupCells: true,
      autoHeight: false,
      thumbnails: false,
      navigationDOM: PREV_SVG + NEXT_SVG
    };
    return '<css-slider data-options=\'' + JSON.stringify(options) + '\' class="css-slider css-slider--overlay-navigation recommendations-slider">' +
      '<div class="grid grid--slider grid-4 grid-portable-3 grid-lap-2 grid-tiny-1 grid--align-items-stretch">' +
      cardHTML +
      '</div>' +
      '</css-slider>';
  }

  function renderRecentlyViewed() {
    var containers = document.querySelectorAll('[data-recently-viewed-container]');
    containers.forEach(function (container) {
      var currentHandle = container.getAttribute('data-current-handle') || '';
      var limit = parseInt(container.getAttribute('data-limit') || '8', 10);
      var handles = readList()
        .filter(function (h) { return h && h !== currentHandle; })
        .slice(0, limit);

      if (handles.length === 0) {
        hideRVTab(container);
        return;
      }

      Promise.all(handles.map(fetchCard)).then(function (results) {
        var cards = results.filter(Boolean);
        if (cards.length === 0) {
          hideRVTab(container);
          return;
        }
        container.innerHTML = buildSliderHTML(cards.join(''));
        showRVTab(container);
      });
    });
  }

  function refreshSlidersIn(el) {
    el.querySelectorAll('css-slider').forEach(function (slider) {
      if (typeof slider.resetSlider === 'function') {
        slider.resetSlider();
      }
    });
  }

  function bindTabs() {
    document.addEventListener('click', function (e) {
      var tab = e.target.closest && e.target.closest('[data-tab]');
      if (!tab) return;
      var group = tab.closest('[data-tab-group]');
      if (!group) return;
      var target = tab.getAttribute('data-tab');

      group.querySelectorAll('[data-tab]').forEach(function (t) {
        var isActive = t === tab;
        t.classList.toggle('is-active', isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      group.querySelectorAll('[data-panel]').forEach(function (p) {
        var isTarget = p.getAttribute('data-panel') === target;
        p.hidden = !isTarget;
        if (isTarget) {
          // Slider sizing relies on offsetWidth, which is 0 while the panel is
          // display:none. Re-measure now that it's visible.
          requestAnimationFrame(function () { refreshSlidersIn(p); });
        }
      });
    });
  }

  function init() {
    logCurrentProduct();
    renderRecentlyViewed();
    bindTabs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
